import { Coins, FileText, Receipt, PieChart } from 'lucide-react';
import { Stitek } from './DodavateleListPanel';

const SECTION_COLOR = '#F59E0B';

const fmtKc = (v) => new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 }).format(v || 0);

/**
 * Hero shrnutí dodavatele — štítky + klíčová čísla „at a glance".
 *
 * Zobrazuje se na užších displejích místo stálé karty vpravo (stejný princip
 * jako RecipeHero u receptur), aby statistiky byly vidět pořád, ne až po
 * přepnutí záložky.
 */
export default function DodavatelHero({ dodavatel, stats, isDark, mutedColor, secondaryColor, isMobile }) {
    const d = stats?.doklady;

    const tiles = [
        { icon: Coins, value: d ? `${fmtKc(d.obrat_12m)}` : '—', unit: d ? ' Kč' : '', label: 'obrat 12 měs.', accent: SECTION_COLOR },
        { icon: FileText, value: d ? d.pocet : '—', label: 'dokladů' },
        { icon: Receipt, value: d ? fmtKc(d.prumer_doklad) : '—', unit: d ? ' Kč' : '', label: 'průměr' },
        { icon: PieChart, value: d?.podil_12m_pct != null ? `${String(d.podil_12m_pct).replace('.', ',')} %` : '—', label: 'z nákupů' },
    ];

    const tileBg = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.02)';
    const tileBorder = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)';

    return (
        <div className="px-4 py-3 space-y-3" style={{ borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'var(--border-default)'}` }}>
            {(dodavatel?.kategorie || []).length > 0 && (
                <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="text-[11px] font-medium" style={{ color: secondaryColor }}>Štítky:</span>
                    {dodavatel.kategorie.map(k => <Stitek key={k.kod} kod={k.kod} nazev={k.nazev} size="md" />)}
                </div>
            )}
            <div className={`grid gap-2 ${isMobile ? 'grid-cols-2' : 'grid-cols-4'}`}>
                {tiles.map((t, i) => {
                    const Icon = t.icon;
                    return (
                        <div key={i} className="rounded-lg px-2.5 py-2 flex items-center gap-2" style={{ background: tileBg, border: `1px solid ${tileBorder}` }}>
                            <Icon size={16} style={{ color: t.accent || mutedColor, flexShrink: 0 }} />
                            <div className="min-w-0">
                                <div className="text-[13px] font-bold leading-tight truncate" style={{ color: t.accent || 'var(--text-primary)' }}>
                                    {t.value}{t.unit ? <span className="text-[10px] font-normal" style={{ color: mutedColor }}>{t.unit}</span> : null}
                                </div>
                                <div className="text-[9px]" style={{ color: mutedColor }}>{t.label}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
